import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (window.opener && !window.opener.closed) {
      window.opener.location.reload()
    }
    window.close()
  }
}
